import { render } from "./EditorArtworkPicker.vue?vue&type=template&id=7c8a8cd6&scoped=true"
import script from "./EditorArtworkPicker.vue?vue&type=script&lang=js"
export * from "./EditorArtworkPicker.vue?vue&type=script&lang=js"

import "./EditorArtworkPicker.vue?vue&type=style&index=0&id=7c8a8cd6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8a8cd6"]])

export default __exports__